import { ErpUI, type iProvider } from "@/app/context/Provider";
import { useContext } from "react";
// import { ErpUI, iProvider } from "../context/Provider";

// Custom hook to use the context
const useGcpsUIController = (): iProvider => {
  const context = useContext(ErpUI);
  if (!context) {
    throw new Error(
      "useGcpsUIController should be used inside the GlobalProvider"
    );
  }
  return context;
};

export default useGcpsUIController;
